import { render, staticRenderFns } from "./AccessesAdvertiserTable.vue?vue&type=template&id=38b222d0&"
import script from "./AccessesAdvertiserTable.vue?vue&type=script&lang=ts&"
export * from "./AccessesAdvertiserTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports